export enum AnketaActionsEnum {
  view = "view",
  create = "create",
  update = "update",
  delete = "delete",
  invite = "invite",
  download = "download",
  // Soft-delete / hide. Previously rode on `update`; now its own action so it can
  // be gated independently (admin + isAutonubil). See .claude/AUTH_RECOMMENDATION.md §4.
  archive = "archive",
}

export type AnketaActions =
  | AnketaActionsEnum.view
  | AnketaActionsEnum.create
  | AnketaActionsEnum.update
  | AnketaActionsEnum.invite
  | AnketaActionsEnum.delete
  | AnketaActionsEnum.archive
  | AnketaActionsEnum.download;
